module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABRElEQVQ4T5WSP0vDYBDGn4tJ6x8yWT+EILi5+QGcxU0XoeokTkLrFUp4A44OGRwEXURBMzhIp04NSje7uGjpIAXpXLVN33gSsFWHpva2u3t+z8HxEEZUsVic7vV6W0R0q5R66sspiSsUCosicgFgHsCpUmpzFEj5fH7XMIxDAA0RmSKiQCm1MRTM5XJzhmGcAVgBcGJZ1p7Wugzg+Q/IzAcDF5GUEGVFZBJA1nVdP94x8z2AeHY90DKzAOhAJJoA0hFwJ8C667ovfREzxxeXvnszNqFvcGe/VffTRF7YfnPs85vHYU9j5m0Axz9gveZbpuXpzodjX5XGAGs130xFXvTedexSeRww8EmbHtpdx65UxgCDwJfPyNPd0JmtVv8NXs6E4cNCs7nWyGRKLdt+TUjUMoDV/nNGRfb3XovIUWJWk9y+AKHInxsMBtS2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/myGive_icon/33.png
// module id = L2aO
// module chunks = 0